import { FASTElement, customElement } from '@microsoft/fast-element';
import { composedParent } from '@microsoft/fast-element/utilities.js';

import template from './template.js';
import styles from './styles.js';

@customElement({
	name: 'site-footer',
	template,
	styles
})
export class Footer extends FASTElement {
	get currentYear() {
		return new Date().getFullYear();
	}

	public scrollToTop(): void {
		window.history.pushState({}, '', '/');

    // ScrollBehavior = "instant" throws as a type error during build for some reason even though it exists in lib.dom.d.ts.
		// @ts-ignore
    document.documentElement.scrollTo({ behavior: 'smooth', top: 0 });
	}
}